import { render, staticRenderFns } from "./FormPatient.vue?vue&type=template&id=b9b70930&scoped=true"
import script from "./FormPatient.vue?vue&type=script&lang=js"
export * from "./FormPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b70930",
  null
  
)

export default component.exports